import angular from 'angular';
import { cloneDeep, pull } from 'lodash';
import { DAYS_OF_WEEK } from '../../values/days_of_week';

module.exports = angular.module('common.components.human-schedules.edit-availability', [
])
.component('odEditHumanAvailabilityGroup', {
  require: ['human', 'availability', 'onDone'],
  bindings: {
    human: '<',
    availability: '<',
    onDone: '&',
    onCancel: '&',
    isCreator: '<'
  },
  template: require('./od-edit-availability.jade')(),
  controller: class EditHumanAvailabilityGroupController {
    // @ngInject
    constructor(AvailableTimes, availableMarkets) {
      this.DAYS_OF_WEEK = DAYS_OF_WEEK;
      this.AVAILABLE_TIMES = AvailableTimes;
      this.AVAILABLE_MARKETS = availableMarkets;
    }

    $onInit() {
      this.reset();
    }

    $onChanges(changes) {
      if (changes.availability) {
        const { currentValue } = changes.availability;
        if (!changes.availability.isFirstChange()) {
          this.reset(currentValue);
        }
      }
    }

    reset(availability) {
      this.workingAvailability = cloneDeep(availability || this.availability);

      this.workingAvailability.availability_windows_attributes =
        this.workingAvailability.availability_windows_attributes || [];
    }

    addTime(dayOfWeek) {
      this.workingAvailability.availability_windows_attributes.push({ 'day_of_week': dayOfWeek });
    }

    removeWindow(availability, windowAttrs) {
      if (windowAttrs.id) {
        windowAttrs._destroy = true;
      } else {
        pull(this.workingAvailability.availability_windows_attributes, windowAttrs);
      }
    }

    saveAvailability() {
      this.onDone({
        availability: this.availability,
        value: this.workingAvailability,
      });
    }
  }
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/human-schedules/od-edit-availability.js
 **/